<template>
    <gmap-map
        ref="map"
        :center="center"
        :zoom="zoomValue"
        :style="mapStyle"
        :options="mapOptions"
        @boundsChanged="$emit('boundsChanged')"
        @idle="centerOnLoad"
    >
        <slot />
    </gmap-map>
</template>

<script>
    export default {
        props: {
            center: {
                required: false,
                type: Object,
                default: () => {
                    return window.defaultMapCenter;
                },
            },
            zoom: {
                required: false,
                type: [Number, String],
                default: 5,
            },
            mapHeight: {
                required: false,
                type: String,
                default: '470px',
            },
            markers: {
                required: false,
                type: Array,
                default: () => {
                    return [];
                },
            },
            disableDefaultUI: {
                required: false,
                type: Boolean,
                default: true,
            },
            disableFullscreen: {
                required: false,
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                initialLoad: true,
                localZoom: this.zoom,
            };
        },

        computed: {
            mapStyle() {
                return `width: 100%; height: ${this.mapHeight}`;
            },

            mapOptions() {
                return {
                    disableDefaultUI : this.disableDefaultUI,
                    mapTypeId: this.disableDefaultUI ? 'roadmap' : 'satellite',
                    fullscreenControl: ! this.disableFullscreen,
                };
            },

            zoomValue() {
                return parseInt(this.localZoom);
            },
        },

        watch: {
            markers() {
                this.fitToBounds();
            },
        },

        methods: {
            centerOnLoad() {
                if (this.initialLoad && this.markers.length) {
                    this.initialLoad = false;
                    this.fitToBounds();
                }
            },

            fitToBounds() {
                if (this.$refs.map && window.google && this.markers.length > 0) {
                    const map = this.$refs.map;
                    const bounds = new google.maps.LatLngBounds();

                    this.markers.forEach(marker => {
                        if (marker.lat && marker.lng) {
                            const position = new google.maps.LatLng(marker.lat, marker.lng);
                            bounds.extend(position);
                        }
                    });

                    map.$mapObject.fitBounds(bounds);

                    if (this.markers.length < 2) {
                        // Since we use fit to bounds we get an insane
                        // zoom level if we have only one marker, thus
                        // we need to set the zoom value again to something else
                        // in order to zoom out again.
                        this.localZoom = this.zoom + 1;
                    }
                }
            },
        },
    };
</script>
